import { watchEffect as o } from "vue";
import { env as s } from "./index551.js";
function m(e, t, r, i) {
  s.isServer || o((n) => {
    e = e ?? window, e.addEventListener(t, r, i), n(() => e.removeEventListener(t, r, i));
  });
}
export {
  m as useEventListener
};
